import userActionTypes from 'redux/users/types';

export const userLoginStart = (userCreds, cb) => ({
  type: userActionTypes.USER_LOGIN_START,
  payload: { userCreds, cb },
});

export const userLoginFailure = (error) => ({
  type: userActionTypes.USER_LOGIN_FAILURE,
  payload: error,
});

export const userLoginSuccess = (user) => ({
  type: userActionTypes.USER_LOGIN_SUCCESS,
  payload: user,
});
